"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWorldCombatInProgress = void 0;
const inventoryWorldMenu_1 = require("../world-menus/inventoryWorldMenu");
const spellbookWorldMenu_1 = require("../world-menus/spellbookWorldMenu");
const isWorldCombatInProgress = () => (spellbookWorldMenu_1.spellbookWorldMenu.isOpen() &&
    spellbookWorldMenu_1.spellbookWorldMenu.state.values.isAwaitingWorldCombat) ||
    (inventoryWorldMenu_1.inventoryWorldMenu.isOpen() &&
        inventoryWorldMenu_1.inventoryWorldMenu.state.values.isAwaitingWorldCombat);
exports.isWorldCombatInProgress = isWorldCombatInProgress;
